import React from "react";
import { connect } from "react-redux";
import { applySpec } from "ramda";
import {
  contributorDialogFieldBlurred,
  contributorDialogFieldChanged,
  contributorDialogRoleChanged,
  saveAddContributor,
  hideContributorDialog,
} from "edit-media/redux/editMediaActions";
import {
  getContributorDialogDisableSave,
  getAddContributorDialogVisible,
  getContributorDialogErrors,
  getContributorDialogFields,
  getContributorRoles,
  getContributorTypes,
} from "common/selectors";
import ContributorDialog from "edit-media/components/ContributorDialog";

const AddContributorDialog = ({
  contributorTypes,
  contributorRoles,
  disableSave,
  errors,
  fields,
  onBlur,
  onCancel,
  onFieldChange,
  onRoleChange,
  onSave,
  title,
  visible,
}) => (
  <ContributorDialog
    title={"Add a New Contributor"}
    contributorRoles={contributorRoles}
    contributorTypes={contributorTypes}
    disableSave={disableSave}
    errors={errors}
    fields={fields}
    onBlur={onBlur}
    onCancel={onCancel}
    onFieldChange={onFieldChange}
    onRoleChange={onRoleChange}
    onSave={onSave}
    saveText={"Add"}
    visible={visible}
  />
);

const mapState = applySpec({
  visible: getAddContributorDialogVisible,
  fields: getContributorDialogFields,
  errors: getContributorDialogErrors,
  contributorRoles: getContributorRoles,
  contributorTypes: getContributorTypes,
  disableSave: getContributorDialogDisableSave,
});

const mapDispatch = dispatch => ({
  onBlur: (field, value) => () =>
    dispatch(contributorDialogFieldBlurred(field, value)),
  onCancel: () => dispatch(hideContributorDialog()),
  onFieldChange: path => value =>
    dispatch(contributorDialogFieldChanged(path, value)),
  onRoleChange: id => dispatch(contributorDialogRoleChanged(id)),
  onSave: id => dispatch(saveAddContributor()),
});

export default connect(mapState, mapDispatch)(AddContributorDialog);
